import { render, staticRenderFns } from "./routine-slider.vue?vue&type=template&id=6f2b136a"
import script from "./routine-slider.vue?vue&type=script&lang=js"
export * from "./routine-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports